import { useEffect, useState } from 'react';
import { TAccessPolicy } from '@ocm_customer/account_pro-ui-access';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import { AxiosResponse } from 'axios';
import { getPolicy } from '../api/b2b/account';

export function usePolicyAPI(): {
  rules: TAccessPolicy[];
  rulesLoaded: boolean;
} {
  const { svocID, userID, isB2BCustomer } = useThdCustomer();
  const [rules, setRules] = useState<TAccessPolicy[]>([]);
  const [rulesLoaded, setRulesLoaded] = useState(false);

  useEffect(() => {
    if (userID && svocID && isB2BCustomer) {
      getPolicy({
        customerSVOCId: svocID,
        customerUserId: userID,
      })
        .then((response: AxiosResponse<TAccessPolicy[]>) => {
          setRules(response.data);
        })
        .catch((error) => {
          console.error('Error fetching policy data:', error);
        })
        .finally(() => {
          setRulesLoaded(true);
        });
    }
  }, [svocID, userID, isB2BCustomer]);

  return { rules, rulesLoaded };
}
